import React, { useState } from "react";
import { toast } from "react-toastify";
import { portalService } from "apiServices";
import { Buttons, Displays, Inputs } from "components";
import {
  DOWNLOAD_BOOKING_TEMPLATE,
  LAST_NEW_FILE,
  PARSE_BOOKING_FILE,
  RENDER_SEAT_BOOKING_ERROR,
} from "utils/functions/seatBooking";

// นำเข้าการจองหลายใบจาก Excel (API ตรวจทั้งไฟล์ ผิดแถวเดียวไม่นำเข้าเลย)
const ImportBookingModal = ({ activityId, onClose, onSuccess }) => {
  const [_isBgLoading, _setIsBgLoading] = useState(false);
  const [_rows, _setRows] = useState([]);
  const [_errors, _setErrors] = useState([]);

  const _handleSelectFile = async (files) => {
    const file = LAST_NEW_FILE(files);
    _setErrors([]);
    if (!file) return _setRows([]);
    try {
      const rows = await PARSE_BOOKING_FILE(file);
      _setRows(rows);
      if (!rows.length) toast.error("ไม่พบข้อมูลในไฟล์ (ตรวจหัวคอลัมน์ตาม Template)");
    } catch (error) {
      _setRows([]);
      toast.error("อ่านไฟล์ไม่ได้");
    }
  };

  const _handleImport = async () => {
    _setIsBgLoading(true);
    const res = await portalService.POST_SEAT_BOOKING_IMPORT(activityId, { rows: _rows });
    _setIsBgLoading(false);
    if (res && res.status === 200) {
      toast.success(`นำเข้าแล้ว ${res.data.bookings} รายการ (${res.data.seats} ที่นั่ง)`);
      onSuccess && onSuccess();
    } else {
      const items = res && res.data && res.data.error && res.data.error.items;
      _setErrors(Array.isArray(items) && typeof items[0] === "object" ? items : []);
      toast.error(RENDER_SEAT_BOOKING_ERROR(res, "นำเข้าไม่สำเร็จ"));
    }
  };

  const groupCount = new Set(_rows.map((r) => r.group).filter(Boolean)).size;

  return (
    <div className="modal_card">
      <Displays.BGLoading visible={_isBgLoading} />
      <div className="modal_title">นำเข้าการจองจาก Excel</div>
      <div className="hint" style={{ marginBottom: 12 }}>
        หนึ่งแถวต่อหนึ่งที่นั่ง แถวที่ "กลุ่มการจอง" เดียวกันคือการจองใบเดียวกัน การจองที่นำเข้าอนุมัติทันทีและบันทึกว่าแอดมินจองให้
      </div>
      <div className="inline_row">
        <div className="w200">
          <Buttons.BgStandard theme_export_btn label="Download Template" onClick={DOWNLOAD_BOOKING_TEMPLATE} />
        </div>
        <div className="w400">
          <Inputs.UploadImage
            theme_upload_image
            acceptType="excel"
            placeholder="เลือกไฟล์ Excel การจอง"
            onChange={_handleSelectFile}
          />
        </div>
      </div>
      {_rows.length > 0 && (
        <div className="info_box">
          พบ {groupCount} การจอง · {_rows.length} ที่นั่ง
        </div>
      )}
      {_errors.length > 0 && (
        <div className="warn_box">
          แก้ไฟล์แล้วนำเข้าใหม่ (ยังไม่มีการนำเข้า):
          <ul>
            {_errors.map((e) => (
              <li key={`${e.line}-${e.message}`}>
                แถว Excel ที่ {e.line}: {e.message}
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="modal_btns">
        <div className="w120">
          <Buttons.BgStandard theme_gray label="ปิด" onClick={onClose} />
        </div>
        <div className="w140">
          <Buttons.BgStandard theme_purple label="นำเข้า" disabled={!_rows.length} onClick={_handleImport} />
        </div>
      </div>
    </div>
  );
};

export default ImportBookingModal;
